import { ApolloClient, ApolloLink } from '@apollo/client/core';
import type { NormalizedCacheObject, DefaultOptions } from '@apollo/client/core';
import { responseHeadersLink } from './response-link';
import { errorLink } from './error-link';
import { authLink } from './auth-link';
import { httpLink } from './http-link';
import { cache } from './cache';
import { getReleaseVersion } from '@/shared/helpers/getAppVersion';

const defaultOptions: DefaultOptions = {
  watchQuery: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'ignore',
  },
  query: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  },
};

export const client: ApolloClient<NormalizedCacheObject> = new ApolloClient({
  link: ApolloLink.from([responseHeadersLink, errorLink, authLink, httpLink]), // chain with links
  cache, // use cache in default
  defaultOptions,
  clientAwareness: {
    name: 'web-customers',
    version: getReleaseVersion(),
  },
});
